import { render } from "./dynamic.vue?vue&type=template&id=9516a022&scoped=true"
import script from "./dynamic.vue?vue&type=script&lang=js"
export * from "./dynamic.vue?vue&type=script&lang=js"

import "./dynamic.vue?vue&type=style&index=0&id=9516a022&lang=scss&scoped=true"
import "./dynamic.vue?vue&type=style&index=1&id=9516a022&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9516a022"]])

export default __exports__